module.exports = __webpack_public_path__ + "static/media/gapinc.9e3c7300.svg";